/**
 * Transition — fades out `.page-transition` overlay on page load (unless the
 * browser supports native View Transitions, in which case this is a no-op).
 *
 * Loaded as ES module via `@theme/transition` importmap entry.
 * Module side-effect: instantiates a singleton on import so the fade-in
 * runs once per page.
 *
 * Dependencies:
 *   - window.theme.showPageTransition (theme.liquid inline config)
 */

export class Transition {
  constructor() {
    this.hasViewTransitions = CSS.supports('view-transition-name', 'root');
    this.pageTransition = document.querySelector('.page-transition');

    if (!this.isPageLoaded) {
      document.addEventListener('DOMContentLoaded', this.onPageLoaded.bind(this));
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.hasViewTransitions) return;
    if (this.pageTransition && window.theme.showPageTransition) {
      this.pageTransition.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: 'forwards',
        easing: 'ease-in-out',
        iterations: 1,
      });
    }
  }

}

new Transition();
